import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { IconButton, Popover } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useState } from 'react';
import {
    saveSearchCondition,
    isViewWasChanged,
    onClickOpenMoveView,
    onHandlerDeleteViewHelpdeskList,
    onHandlerHideViewHelpdeskList
} from '../../handler/HelpDeskViewHandler';

export const SettingView = props => {
    const {
        API,
        view,
        setIsLoadingView,
        listView,
        setListView,
        viewSelected,
        setViewSelected,
        viewStructure,
        setViewStructure,
        isProjectManager,
        setIsOpenDialogViewChanged
    } = props;
    const [isConfirmDeleteView, setIsConfirmDeleteView] = useState(false);
    const [isConfirmHideView, setIsConfirmHideView] = useState(false);
    const [openSettingMenu, setOpenSettingMenu] = useState(null);

    const onClickViewSetting = event => {
        setOpenSettingMenu(event.currentTarget);
    };

    const handleClose = () => {
        setOpenSettingMenu(null);
    };

    const onClickDeleteView = async () => {
        setIsLoadingView(true);
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        setIsLoadingView(false);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmDeleteView(true);
        }
    };

    const onClickHideView = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            setIsConfirmHideView(true);
        }
    };

    const onClickSaveSearchCondition = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            await saveSearchCondition(
                API,
                view,
                setIsLoadingView,
                viewStructure,
                listView,
                setListView,
                viewSelected,
                setViewSelected
            );
        }
    };

    const onClickMoveView = async () => {
        setOpenSettingMenu(null);

        //check view was changed
        let isViewChanged = await isViewWasChanged(view, props);
        if (isViewChanged) {
            setIsOpenDialogViewChanged(true);
        } else {
            onClickOpenMoveView(view, props);
        }
    };

    const isDisplayBtnSettingViewIcon = () => {
        if (
            viewStructure?.visibility === Constant.VISIBILITY_SETTING_TYPE.PROJECT &&
            !isProjectManager
        )
            return false;
        return true;
    };

    const onClickCloseConfirmDeleteView = () => {
        setIsConfirmDeleteView(false);
    };

    const onClickOkConfirmDeleteView = () => {
        onHandlerDeleteViewHelpdeskList(
            API,
            view,
            setIsConfirmDeleteView,
            setIsLoadingView,
            listView,
            setListView,
            viewSelected,
            setViewSelected,
            viewStructure,
            setViewStructure
        );
    };

    const onClickCloseConfirmHideView = () => {
        setIsConfirmHideView(false);
    };

    const onClickOkConfirmHideView = () => {
        onHandlerHideViewHelpdeskList(
            API,
            view,
            setIsConfirmHideView,
            setIsLoadingView,
            listView,
            setListView,
            viewSelected,
            setViewSelected,
            viewStructure,
            setViewStructure
        );
    };

    return (
        <>
            {isDisplayBtnSettingViewIcon() && (
                <IconButton
                    className="btn-showMore"
                    onClick={onClickViewSetting}
                    style={{ verticalAlign: 'middle', padding: '4px 10px' }}
                >
                    <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                </IconButton>
            )}
            <Popover
                className="navTabs-dropMenu"
                id={Boolean(openSettingMenu) ? 'simple-popover' : undefined}
                open={Boolean(openSettingMenu)}
                anchorEl={openSettingMenu}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <ul>
                    <li onClick={onClickHideView}>
                        <span className="navTabs-item">
                            <img src="/assets/image/icon-tabs-hide.svg" alt="" />
                        </span>
                        <span className="navTabs-text">非表示</span>
                    </li>
                    {view.viewType === Constant.VIEW_TYPE.CUSTOM && (
                        <li onClick={onClickDeleteView}>
                            <span className="navTabs-item">
                                <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                            </span>
                            <span className="navTabs-text">削除</span>
                        </li>
                    )}
                    <li onClick={onClickMoveView}>
                        <span className="navTabs-item">
                            <img src="/assets/image/icon-tabs-move.svg" alt="" />
                        </span>
                        <span className="navTabs-text">移動</span>
                    </li>
                    {view.viewType === Constant.VIEW_TYPE.CUSTOM && (
                        <li onClick={onClickSaveSearchCondition}>
                            <span className="navTabs-item">
                                <img src="/assets/image/icon-tabs-search.svg" alt="" />
                            </span>
                            <span className="navTabs-text">検索条件保存</span>
                        </li>
                    )}
                </ul>
            </Popover>

            {/* Dialog confirm delete view */}
            <ConfirmDialog
                isOpen={isConfirmDeleteView}
                msgConfirm={I18n.get('COMMSG029')}
                closeCallBack={onClickCloseConfirmDeleteView}
                okCallBack={onClickOkConfirmDeleteView}
                textClose={I18n.get('COMBTN007')}
            />

            {/* Dialog confirm hide view */}
            <ConfirmDialog
                isOpen={isConfirmHideView}
                msgConfirm={I18n.get('COMMSG032')}
                closeCallBack={onClickCloseConfirmHideView}
                okCallBack={onClickOkConfirmHideView}
                textClose={I18n.get('COMBTN007')}
            />
        </>
    );
};
